"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableFieldToolbar = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const ControlPoint_1 = __importDefault(require("@material-ui/icons/ControlPoint"));
const Delete_1 = __importDefault(require("@material-ui/icons/Delete"));
const Edit_1 = __importDefault(require("@material-ui/icons/Edit"));
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const table_field_styles_1 = require("./table-field-styles");
const table_field_context_1 = require("./table-field-context");
const table_field_toolbar_button_1 = require("./table-field-toolbar-button");
function TableFieldToolbar({ selectedIndex }) {
    const classes = table_field_styles_1.useStyles();
    const { showAddDialog, showEditDialog, showRemoveDialog, disabled, disabledAdd, disabledEdit, disabledRemove, visibleAdd, visibleEdit, visibleRemove, } = react_1.useContext(table_field_context_1.TableFieldContext);
    const handleAddClick = event_callback_hook_1.useEventCallback(() => showAddDialog());
    const handleEditClick = event_callback_hook_1.useEventCallback(() => {
        if (selectedIndex !== undefined) {
            showEditDialog(selectedIndex);
        }
    });
    const handleRemoveClick = event_callback_hook_1.useEventCallback(() => {
        if (selectedIndex !== undefined) {
            showRemoveDialog(selectedIndex);
        }
    });
    return (react_1.default.createElement("div", { className: classes.tableActions },
        react_1.default.createElement("div", { className: classes.buttonGroup },
            react_1.default.createElement(table_field_toolbar_button_1.TableFieldToolbarButton, { title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_FIELD_TOOLBAR_BTN_ADD", defaultMessage: "P\u0159idat" }), onClick: handleAddClick, IconComponent: ControlPoint_1.default, disabled: disabled || disabledAdd, show: visibleAdd }),
            react_1.default.createElement(table_field_toolbar_button_1.TableFieldToolbarButton, { title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_FIELD_TOOLBAR_BTN_EDIT", defaultMessage: "Upravit" }), onClick: handleEditClick, IconComponent: Edit_1.default, disabled: disabled || disabledEdit || selectedIndex === undefined, show: visibleEdit }),
            react_1.default.createElement(table_field_toolbar_button_1.TableFieldToolbarButton, { title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_FIELD_TOOLBAR_BTN_DELETE", defaultMessage: "Smazat" }), onClick: handleRemoveClick, IconComponent: Delete_1.default, disabled: disabled || disabledRemove || selectedIndex === undefined, show: visibleRemove }))));
}
exports.TableFieldToolbar = TableFieldToolbar;
//# sourceMappingURL=table-field-toolbar.js.map